import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import { Currency } from 'features/shared/enums/currency';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InvoiceRecapitulationDTO from '../dtos/InvoiceRecapitulationDTO';
import { InvoiceRecapitulationType } from '../enums/invoiceRecapitulationType';
import { InvoiceType } from '../enums/invoiceType';

interface Props {
  recapitulationItem: InvoiceRecapitulationDTO;
  currency: Currency;
  invoiceType: InvoiceType;
}

const InvoiceRecapitulationTotalItem = ({ recapitulationItem, currency, invoiceType }: Props) => {
  // translation
  const { t } = useTranslation(["invoice\\enums\\invoiceRecapitulationType"]);

  // helpers
  const getTotalText = (amount?: number, type?: InvoiceType) => {
    if (type === InvoiceType.Proformainvoice) {
      return t(`${InvoiceRecapitulationType.Total}.AdvanceTotal`);
    } else if (type === InvoiceType.Invoice) {
      if (amount && amount > 0) {
        return t(`${InvoiceRecapitulationType.Total}.UnpaidBalance`);
      } else if (amount && amount < 0) {
        return t(`${InvoiceRecapitulationType.Total}.Overpayment`);
      }
    }

    return t(`${InvoiceRecapitulationType.Total}.AdvanceTotal`);
  }

  const getContextClass = (amount?: number, type?: InvoiceType) => {
    if (type === InvoiceType.Invoice) {
      if (amount && amount > 0) {
        return " alert alert-danger p-2 mb-0 mt-2 border-0";
      } else if (amount && amount < 0) {
        return " alert alert-success p-2 mb-0 mt-2 border-0";
      }
    }

    return "";
  }  

  // render
  return (
    <div className={`d-flex justify-content-between font-weight-bold${getContextClass(recapitulationItem.taxInclusiveAmount, invoiceType)}`}>
      <span>{getTotalText(recapitulationItem.taxInclusiveAmount, invoiceType)}</span>
      <span>
        <PriceFormatter amount={recapitulationItem.taxInclusiveAmount!} currency={currency} decimalPlaces={2} />
      </span>
    </div>
  );
}

export default InvoiceRecapitulationTotalItem;
